import React from "react";
import '../../assets/css/contact.css'
import { NavLink } from "react-router-dom";
export default function Contact(){
    return(
        <>
        {/* 🔥 CONTACT HERO */}
<section className="contactHeroNew">

  {/* Background Effects */}
  <div className="hero-glow one"></div>
  <div className="hero-glow two"></div>

  <div className="hero-content">

    <h4>CONTACT US</h4>

    <h1>
      Get in Touch <br />
      <span>with Trip Word</span>
    </h1>

    <p>
      We are here to help you plan your perfect journey! <br />
      Travel stress-free with expert support & seamless booking.
    </p>

<div className="hero-buttons">
  <NavLink 
    to="/services" 
    className="hero-btn primary"
    style={{ textDecoration: "none" }}
  >
    Start Planning ✈️
  </NavLink>

  {/* <button className="hero-btn secondary"> */}
   <a 
    href="tel:+91 9699581519" 
    className="hero-btn secondary"
    style={{ textDecoration: "none" }}
  >
    Call Now 📞
  </a>
  {/* </button> */}
</div>

  </div>

</section>

<section className="contactUltra">

  <h2 className="ultraTitle">
    Let’s <span>Connect</span>
  </h2>

  <div className="ultraWrap">

    {/* PHONE */}
    <a href="tel:+91 9699581519" className="ultraItem  shadow-lg">
      <div className="iconBox">📞</div>
      <div className="textBox">
        <h4>Call Us</h4>
        <p>+91 9699581519</p>
      </div>
    </a>

    {/* WHATSAPP */}
    <a href="https://wa.me/+91 9699581519" className="ultraItem  shadow-lg">
      <div className="iconBox">💬</div>
      <div className="textBox">
        <h4>WhatsApp</h4>
        <p>Chat with us instantly</p>
      </div>
    </a>

    {/* EMAIL */}
    <a href="mailto:info@tripword.com" className="ultraItem  shadow-lg">
      <div className="iconBox">📧</div>
      <div className="textBox">
        <h4>Email</h4>
        <p>info@tripword.in</p>
      </div>
    </a>

    {/* WEBSITE */}
    <a href="/" className="ultraItem  shadow-lg">
      <div className="iconBox">🌐</div>
      <div className="textBox">
        <h4>Website</h4>
        <p>tripword.in</p>
      </div>
    </a>

  </div>

</section>

<section className="officePro">

  {/* LEFT */}
  <div className="office-left">
    <h2>
      Our <span>Office</span>
    </h2>

    <p className="office-text">
      Visit us or connect with us anytime.  
      We are always ready to plan your perfect journey.
    </p>

    <div className="office-address">
      <span className="location-icon">📍</span>
      <p>Ahilyanagar, Maharashtra, India</p>
   
    </div>
      <div className="office-address">
      <span className="location-icon">📍</span>
      <p>Opposite Shevgaon Bus Stand,
Shevgaon, Maharashtra, India</p>
    </div>
  </div>

  {/* RIGHT (MAP STYLE BOX) */}
  <div className="office-map">
    <div className="map-overlay">
      <h3>Trip Word</h3>
      <p>Travel & Event Agency</p>
    </div>
  </div>

</section>

<section className="whyChooseUltra">

  <h2>Why <span>Choose Us</span></h2>

  <div className="whyWrap">

    <div className="whyCard">
      <h3>🌍 Expert Planning</h3>
      <p>We create personalized travel plans tailored to your needs.</p>
    </div>

    <div className="whyCard">
      <h3>💰 Best Pricing</h3>
      <p>Get the most affordable packages without compromising quality.</p>
    </div>

    <div className="whyCard">
      <h3>⚡ Fast Booking</h3>
      <p>Quick and hassle-free booking experience with instant support.</p>
    </div>

    <div className="whyCard">
      <h3>🤝 24/7 Support</h3>
      <p>We are always available to assist you anytime, anywhere.</p>
    </div>

  </div>

</section>

<section className="testimonialUltra">

  <h2>Happy <span>Travelers</span></h2>

  <div className="testimonialWrap">

    <div className="testimonialCard">
      <p>"Amazing service! Everything was perfectly planned."</p>
      <h4>- Rahul Sharma</h4>
    </div>

    <div className="testimonialCard">
      <p>"Best travel agency! Highly recommended 👍"</p>
      <h4>- Sneha Patil</h4>
    </div>

    <div className="testimonialCard">
      <p>"Smooth booking and great support throughout the trip."</p>
      <h4>- Amit Verma</h4>
    </div>

  </div>

</section>
        </>
    )
}